// The "能力" menu groups skills, plugins and MCP, each with its own enterprise route permission.
export const SKILLS_PATH = '/console/skills';
export const MCP_PATH = '/console/mcp';
export const PLUGINS_PATH = '/console/plugins';

function canAccess(path: string): boolean {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (!user.authorizedRoute) return true;
    return (user.authorizedRouteList || []).includes(path);
  } catch {
    return true;
  }
}

export const canAccessSkills = (): boolean => canAccess(SKILLS_PATH);
export const canAccessMcp = (): boolean => canAccess(MCP_PATH);
export const canAccessPlugins = (): boolean => canAccess(PLUGINS_PATH);

/** The first tab the member may open. Order matches the tabs on the ability page. */
export function abilityEntryPath(): string {
  if (canAccessSkills()) return SKILLS_PATH;
  if (canAccessPlugins()) return PLUGINS_PATH;
  if (canAccessMcp()) return MCP_PATH;
  return '/401';
}
